const pendingMfaStorageKey = 'le-refuge.pending-mfa-challenge'

export const setPendingMfaChallenge = challenge => {
  if (!challenge || !challenge.challenge_id) {
    return
  }

  const safeChallenge = {
    challenge_id: challenge.challenge_id,
    masked_email: challenge.masked_email,
    expires_at: challenge.expires_at,
    resend_available_at: challenge.resend_available_at,
  }

  sessionStorage.setItem(pendingMfaStorageKey, JSON.stringify(safeChallenge))
}

export const getPendingMfaChallenge = () => {
  const storedChallenge = sessionStorage.getItem(pendingMfaStorageKey)
  if (!storedChallenge) {
    return null
  }

  try {
    const challenge = JSON.parse(storedChallenge)
    if (!challenge || typeof challenge.challenge_id !== 'string') {
      return null
    }

    return challenge
  } catch (error) {
    return null
  }
}

export const clearPendingMfaChallenge = () => {
  sessionStorage.removeItem(pendingMfaStorageKey)
}

export const isMfaChallengeExpired = challenge => {
  const expiresAt = Date.parse(challenge?.expires_at)
  return Number.isNaN(expiresAt) || expiresAt <= Date.now()
}
